module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAAR0lEQVQ4y2P4jwQ+MAww7wADDNgPPI8f6KYDg4j3//+fwcIDOov5/6Dg/WEAJRyGQcEDuYz/z+Dg/WFATj0DyhtEeXrwlHUADinPp7xFowAAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDMrMDk6MDB5Ddv1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00539_100x100.png
// module id = Wv3T
// module chunks = 0